module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/isana_peel_off_social_media_spot.jpg";